/**
 * mini addon to use lazyload
 *   <img class="lazyload" data-src="${picure-url}"/>
 */
$(function () {
    $('.lazyload').each(function () {
        let src = $(this).attr('data-src');
        $(this).attr('src', src);
    });
});